import { connect } from 'react-redux'
import { changeEventsModal } from 'src/actions/event'

import {
  eventCommentsCountSelector,
  eventSelector,
  eventUpdatesCountSelector,
  mediaCountSelector,
  tabRoutesSelector,
  visibleEventCommentsSelector,
  eventModalSelector
} from 'src/selectors'

import EventSections from './EventSections'

function mapStateToProps(state) {
  const event = eventSelector(state)
  const totalCommentsCount = visibleEventCommentsSelector(state).length

  const mediaCount = mediaCountSelector(state)

  const unreadMediaCount = event.processed_media_count - mediaCount
  const unreadCommentsCount = totalCommentsCount - eventCommentsCountSelector(state)

  return {
    event,
    eventUpdatesCount: eventUpdatesCountSelector(state),
    mediaCount,
    unreadMediaCount,
    unreadCommentsCount,
    tabRoutes: tabRoutesSelector(state),
    eventModal: eventModalSelector(state)
  }
}

function mapDispatchToProps(dispatch) {
  return {
    onChangeEventModal: tab => {
      dispatch(changeEventsModal(tab))
      window.scrollTo(0, 0)
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(EventSections)
